import ContentfulApi from '../../services/contentfulApi';

export function getTooltips(page: any) {
  return ContentfulApi.getEntries({
    content_type: 'tooltip',
    select: ['sys.id', 'fields.text', 'fields.identifier'].join(','),
  });
}
